module.exports = __webpack_public_path__ + "img/zhuangxiangji3.dcf027fe.jpg";